import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import wordpress from './modules/wordpress'
import createLogger from 'vuex/dist/logger'

Vue.use(Vuex)

/**
 * Plugins for WordPress module
 */
const localStoragePlugin = store => {
  store.subscribe((mutation, state) => {
    if (mutation.type === 'wordpress/account/url') localStorage.setItem('url', state.wordpress.account.url)
    if (mutation.type === 'wordpress/account/username') localStorage.setItem('username', state.wordpress.account.username)
    if (mutation.type === 'wordpress/account/password') localStorage.setItem('password', state.wordpress.account.password)

    if (mutation.type === 'wordpress/account/login') {
      localStorage.setItem('token', state.wordpress.account.token)
      localStorage.setItem('email', state.wordpress.account.email)
    }

    if (mutation.type === 'wordpress/account/getId') {
      localStorage.setItem('id', state.wordpress.account.id)
    }

    // ログアウト時にストレージのtoken等を破棄する
    if (mutation.type === 'wordpress/account/logout') {
      localStorage.removeItem('jwt')
      localStorage.removeItem('id')
      localStorage.removeItem('email')
    }
  })
}

export default new Vuex.Store({
  namespaced: true,
  plugins: process.env.NODE_ENV !== 'production' ? [createLogger(), localStoragePlugin] : [localStoragePlugin],
  modules: {
    app,
    wordpress,
    strict: process.env.NODE_ENV !== 'production'
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js